import NoticeDetails from "../components/pages/Notice/NoticeDetails";

export default function NoticeDetailsPage() {
  return (
    <>
      <NoticeDetails />
    </>
  );
}
